<script>
import { useWidgetPlanning, widgetPlanningProps } from "./mixin";
import WidgetPlanningTab from "./widget-planning-tab/default";
import Tabs from "@/components/molecules/tabs";
import Tab from "@/components/molecules/tabs/tab";
import Titre from "@/components/atoms/titre";
import BandeauBascule from "@/components/organisms/banniere-bascule";

export default {
  name: "WidgetPlanning",
  components: { Tabs, Tab, WidgetPlanningTab, Titre, BandeauBascule },
  props: { ...widgetPlanningProps() },

  setup(props) {
    const { mounted, getIconNameForModeCommande, setActiveTab, activeTab } =
      useWidgetPlanning(props);
    const tabs = ref(null);
    onMounted(() => {
      mounted();
    });

    return {
      tabs,
      getIconNameForModeCommande,
      activeTab,
      setActiveTab
    };
  }
};
</script>

<template>
  <div>
    <Titre
      tag="h1"
      variant="primary"
      class="u-text-center u-mb-md"
    >
      Les prochains créneaux disponibles <br>
      dans votre magasin {{ magasinName }}
    </Titre>
    <BandeauBascule
      v-if="isDispoCarrefour"
      :jour-dispo="jourPremierCreneauCarrefour"
    />
    <Tabs
      slidable
      :active-index="activeTab"
      :tabs-template-refs="tabs"
      @tabSelected="setActiveTab"
    >
      <Tab
        v-for="(mdc, index) in modesCommande"
        ref="tabs"
        :key="mdc.type"
        :is-active="activeTab === index"
        :title="mdc.label"
        :icon-name="getIconNameForModeCommande(mdc.type_picto.code)"
        icon-color="primary"
      >
        <WidgetPlanningTab
          :mode-commande="mdc"
          :commune-lad="commune"
          :magasin="magasin"
          class="u-p-md"
        />
      </Tab>
    </Tabs>
  </div>
</template>

<style lang="scss" scoped>
</style>
